// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"243e9635","86":"610590ee","296":"4096c521","780":"3d28c39b","973":"7310a0bb"}[chunkId] + ".chunk.js";
};